var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hidePaymentPlans
    ? _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          {
            staticClass: "d-flex align-items-center justify-content-start mb-0"
          },
          [
            _c("AppToggle", {
              staticClass: "mr-2",
              attrs: { size: "sm", disabled: _vm.paymentPlanDisable },
              model: {
                value: _vm.value.enabled,
                callback: function($$v) {
                  _vm.$set(_vm.value, "enabled", $$v)
                },
                expression: "value.enabled"
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "para-3 mb-0 d-inline-flex align-items-center" },
              [_vm._v("Add Payment Plan ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.value.enabled
          ? _c("div", { staticClass: "sub-options" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "price-input-section mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "price-wrapper",
                    class: { "form-error": _vm.validation.amount.$error }
                  },
                  [
                    _c("AppInput", {
                      attrs: {
                        label: `${_vm.$t(
                          "Total Price"
                        )}(${_vm.getCurrencySymbol(_vm.currency)}) *`,
                        "input-class": "mb-1",
                        placeholder: "",
                        type: "number",
                        hasPrecision: "",
                        "data-test-id": "Number"
                      },
                      on: { blur: _vm.validation.$touch },
                      model: {
                        value: _vm.value.amount,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "amount", _vm._n($$v))
                        },
                        expression: "value.amount"
                      }
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "stan-text-danger error" }, [
                      _vm._v(_vm._s(_vm.price_validation_error_message))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "price-wrapper mb-3",
                    class: { "form-error": _vm.validation.interval.$error }
                  },
                  [
                    _c("div", [
                      _c("label", { staticClass: "control-label mr-1" }, [
                        _vm._v(_vm._s(_vm.$t("Repeat every")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("AppDropdown", {
                      staticClass: "form-control h-auto",
                      attrs: {
                        searchable: false,
                        options: [
                          { label: "Yearly", value: "year" },
                          { label: "Monthly", value: "month" },
                          { label: "Weekly", value: "week" },
                          { label: "Bi-weekly", value: "bi-week" },
                          { label: "Daily", value: "day" }
                        ],
                        reduce: "value"
                      },
                      on: { blur: _vm.validation.interval.$touch },
                      model: {
                        value: _vm.value.interval,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "interval", $$v)
                        },
                        expression: "value.interval"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-input-section" }, [
                _c(
                  "div",
                  { staticClass: "price-wrapper" },
                  [
                    _c("div", [
                      _c("label", { staticClass: "control-label" }, [
                        _c("span", { staticClass: "mr-1" }, [
                          _vm._v(_vm._s(_vm.$t("# Payments")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("AppDropdown", {
                      staticClass: "form-control h-auto px-2",
                      attrs: {
                        searchable: false,
                        options: _vm.durationOptions,
                        reduce: "value",
                        disabled: _vm.validation.amount.$error
                      },
                      on: { blur: _vm.validation.$touch },
                      model: {
                        value: _vm.value.duration,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "duration", $$v)
                        },
                        expression: "value.duration"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.validation.amount.$error && this.value.duration
                ? _c(
                    "span",
                    {
                      staticClass:
                        "color-gray para-3 d-inline-flex align-items-center mb-3 mt-1"
                    },
                    [
                      _vm._v(
                        "\n\t\t\tYour customer will pay " +
                          _vm._s(this.value.duration) +
                          " payments of " +
                          _vm._s(this.onePaymentAmount) +
                          " each.\n\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2 mt-1" }, [
      _c(
        "span",
        {
          staticClass: "para-3 mb-0 d-inline-flex align-items-center text-light"
        },
        [
          _vm._v(
            "Stan automatically includes Afterpay and Klarna for your fans. You can also offer your own custom payment plan below. Remember,\n\t\t\t\tthat you would have to take the risk if they don't pay. Tip: Creators often charge more for payment plans to encourage upfront\n\t\t\t\tpayment."
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }